import { StyleSheet } from 'aphrodite';
import { THEME } from '../../web/components-v2/Theme/theme';
import { label } from '../../web/styles/colors';
import { BreakPoints } from '../../web/styles/styles';
import { MobileBreakpoint } from '../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {},
	errorMessage: {
		margin: 0,
	},
	labelWithIcon: {
		boxSizing: 'border-box',
		color: label,
		margin: 0,
		textWrap: 'wrap',
		marginTop: 10,
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	meetingDescription: {
		marginTop: 6,
		maxHeight: 300,
		overflowY: 'auto',
		...THEME.common.scrollBar,
	},
	meetingName: {
		fontSize: 18,
		[BreakPoints.forMaxWidth(MobileBreakpoint)]: {
			fontSize: 14,
		},
		textWrap: 'wrap',
	},
});
